/*global $*/

import ko from 'knockout';

export function registerComponent() {
  ko.components.register('period-chip', {
    template: `<label data-bind="visible: visible, html: text, click: remove"></label>`,
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new PeriodChipViewModel(params, componentInfo);
      },
    },
  });
}

// eslint-disable-next-line no-unused-vars
function PeriodChipViewModel(params, componentInfo) {
  var self = this;

  self.text = ko.pureComputed(function () {
    var arrival = parseArrival(params.data.Arrival());
    var duration = parseDuration(params.data.Duration());
    if (arrival && duration) {
      var departure = addDays(arrival, duration);
      return (arrival.getDate() + '.' + (arrival.getMonth() + 1) + '.' + arrival.getFullYear() + '-' + departure.getDate() + '.' + (departure.getMonth() + 1) + '.' + departure.getFullYear());
    }
    return '';
  }, self);

  self.visible = ko.pureComputed(function () {
    return parseArrival(params.data.Arrival()) && parseDuration(params.data.Duration());
  }, self);

  self.remove = function (data, event) {
    var $form = $(event.currentTarget).closest('form');
    params.data.Arrival('');
    params.data.Duration(null);
    $form.trigger('update');
  };
}

function addDays(date, days) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
}

function parseArrival(arrival) {
  var parts = arrival.split(/[\s\-./]+/);
  if (parts.length !== 3) {
    return null;
  } else {
    return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
  }
}

function parseDuration(duration) {
  return parseInt(duration);
}
